import { Bookmark, PlusCircle } from "react-feather";
import { Nav } from "reactstrap";
import { Btn, LI } from "../../../AbstractElements";
import { Href, NewBookmark, Tags, Views } from "../../../Constant";
import { BOOKMARK_SIDE_DATA, BOOKMARK_TAG_DATA } from "../../../Data/Bookmark";
import { useAppDispatch, useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { setAddModal, setTagModal, updateActiveTabs } from "../../../Redux-Toolkit/Reducers/BookmarkTabSlice";
import BookmarkModal from "./ModalBookMark";
import ModalTag from "./ModalTag";

const NavTab = () => {
  const { activeTabs } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();
  const onHandleClick = (id: string) => {dispatch(updateActiveTabs(id));};

  return (
    <Nav className="main-menu" role="tablist">
      <LI>
        <Btn className="badge-light-primary d-block w-100 btn-mail" onClick={()=>dispatch(setAddModal())}>
          <Bookmark className="me-2"/>{NewBookmark}
          <BookmarkModal />
        </Btn>
      </LI>
      <LI><span className="main-title f-w-700">{Views}</span></LI>
      {BOOKMARK_SIDE_DATA.map((data, index) => (
        <LI key={index}>
          <a className={`show ${activeTabs === data.value ? "active" : ""}`} onClick={() => onHandleClick(data.value)} href={Href}>
            <span className="title"> {data.title}</span>
          </a>
        </LI>
      ))}
      <LI><hr /></LI>
      <LI>
        <span className="main-title f-w-700">{Tags}
          <span className="pull-right" onClick={()=>dispatch(setTagModal())}><a href={Href}><PlusCircle /></a></span>
        </span>
      </LI>
      <ModalTag />
      {BOOKMARK_TAG_DATA.map((data, index) => (
        <LI key={index}>
          <a className={`show ${activeTabs === data.value ? "active" : ""}`} onClick={() => onHandleClick(data.value)} href={Href}>
            <span className="title"> {data.title}</span>
          </a>
        </LI>
      ))}
    </Nav>
  );
};

export default NavTab;